var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4563 7.8C15.4375 7.75 14.9063 6.575 13.7313 5.39375C12.1625 3.83125 10.1813 3 8.00004 3C5.81879 3 3.83754 3.83125 2.26878 5.39375C1.09378 6.575 0.562535 7.75 0.543785 7.8C0.51588 7.86298 0.501465 7.93111 0.501465 8C0.501465 8.06889 0.51588 8.13702 0.543785 8.2C0.562535 8.25 1.09378 9.425 2.26878 10.6062C3.83754 12.1687 5.81879 13 8.00004 13C10.1813 13 12.1625 12.1687 13.7313 10.6062C14.9063 9.425 15.4375 8.25 15.4563 8.2C15.4842 8.13702 15.4986 8.06889 15.4986 8C15.4986 7.93111 15.4842 7.86298 15.4563 7.8V7.8ZM8.00004 5.75C8.44504 5.75 8.88006 5.88196 9.25007 6.12919C9.62008 6.37643 9.90847 6.72783 10.0788 7.13896C10.2491 7.5501 10.2936 8.0025 10.2068 8.43895C10.12 8.87541 9.90569 9.27632 9.59103 9.59099C9.27636 9.90566 8.87545 10.12 8.43899 10.2068C8.00253 10.2936 7.55013 10.249 7.139 10.0787C6.72786 9.90843 6.37646 9.62004 6.12923 9.25003C5.882 8.88002 5.75004 8.44501 5.75004 8C5.75004 7.40326 5.98709 6.83097 6.40905 6.40901C6.831 5.98705 7.4033 5.75 8.00004 5.75V5.75Z",
    fill: "#1B1D21"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.44ab1bf28f38d188ac58ef0281e67711.svg";
export { ForwardRef as ReactComponent };